import { Dispatch, SetStateAction } from 'react';
import { Form } from 'react-bootstrap';
import { CustomPresetState } from '@blisspointmedia/bpm-types/dist/RelativeDatePresets';
import { Button } from '../../Button';
import { Design, Placement } from '../../designConstants';
import { Dropdown } from '../../Dropdown';
import {
  CUSTOM_PRESET_INTERVAL,
  CUSTOM_PRESET_REFERENCE
} from '../DatePickerButton/DatePickerConstants';

interface SinglePresetProps {
  label: 'Start' | 'End';
  customPresetState: CustomPresetState;
  setCustomPresetState: Dispatch<SetStateAction<CustomPresetState>>;
  rangeError: boolean;
  disabled?: boolean;
}

export const SingleCustomDatePreset = ({
  customPresetState,
  setCustomPresetState,
  disabled,
  rangeError,
  label
}: SinglePresetProps) => (
  <>
    <div className='custom-date-preset-container'>
      <div className='preset-title'>{label}</div>
      <div className='dp-presets-controls-container'>
        <Button design={Design.NEUTRAL} className='number-input-container' disabled={disabled}>
          <Form.Control
            size='sm'
            className='days-input'
            type='number'
            placeholder='X'
            value={customPresetState.number === undefined ? '' : customPresetState.number}
            onChange={e => {
              e.persist();
              const value = e.target.value === '' ? undefined : Number(e.target.value);
              setCustomPresetState(c => ({ ...c, number: value }));
            }}
            disabled={disabled}
          />
        </Button>
        <Dropdown
          overlayPlacement={Placement.RIGHT}
          value={customPresetState.interval}
          options={CUSTOM_PRESET_INTERVAL}
          onChange={value => setCustomPresetState(c => ({ ...c, interval: value }))}
          disabled={disabled}
        />
        <Dropdown
          overlayPlacement={Placement.RIGHT}
          value={customPresetState.before ? 'Before' : 'After'}
          options={['Before', 'After']}
          onChange={value => setCustomPresetState(c => ({ ...c, before: value === 'Before' }))}
          disabled={disabled}
        />
        <Dropdown
          overlayPlacement={Placement.RIGHT}
          value={customPresetState.referenceDate}
          options={CUSTOM_PRESET_REFERENCE}
          onChange={value => setCustomPresetState(c => ({ ...c, referenceDate: value }))}
          disabled={disabled}
        />
      </div>
    </div>
    {!disabled && rangeError && <div className='range-error'>Outside date range</div>}
  </>
);
